<template>
	<v-card class="flex round-card background-2 w100p" :elevation="field ? 0 : elevation" >
        <template v-if="field">
            <v-subheader class="pl-0">{{ field.label }}</v-subheader>
            <div class="caption"> {{ field.caption }} </div>
        </template>
        <v-card class="flex round-card background-2" :class="{'pb-4': expand}" elevation="0" v-else>
            <v-card-title class="pa-3">
				<p class="pl-2 pl-xl-3">Upload Documenti</p>
				<v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-menu bottom left>
					<template v-slot:activator="{ on }">
						<v-btn icon v-on="on">
							<v-icon>more_vert</v-icon>
						</v-btn>
					</template>
                    <v-list dense>
                        <v-list-item @click="confirmDelete = true">
                            <v-list-item-title>Elimina tutti</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" @click="expand = !expand" icon>
                            <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
                        </v-btn>
                    </template>                    
                    <span>{{ expand ? 'Contrai' : 'Espandi' }}</span>
                </v-tooltip>
			</v-card-title>
        	<v-divider v-show="expand"></v-divider>
			<v-progress-linear v-show="expand"
				height="2"
				:indeterminate="progressIndeterminate"
				:active="progressActive">
			</v-progress-linear>
        </v-card>
		<v-expand-transition>
			<vue-dropzone
				@vdropzone-mounted="initDropzone"
				v-show="expand"
				:useCustomSlot="true"
				:destroy-dropzone="true"
				ref="myVueDropzone"
				id="dropzone"
				class="pb-8 round-card background-2"
				:options="mergedOptions"
				style="height: auto; min-height: 150px;"
				:include-styling="false"
				v-on:vdropzone-sending="sendingEvent"
				v-on:vdropzone-removed-file="deleteFile"
				v-on:vdropzone-success="successUpload"
				v-on:vdropzone-thumbnail="thumbnail"
				v-on:vdropzone-file-added="toggleProgress(true)"
				v-on:vdropzone-error="maxSizeExceded"
				v-on:vdropzone-max-files-reached="maxFilesReached">
				<div style="display: flex; flex-wrap: wrap; gap: 8px;">
					<div class="fileinput-button el-upload el-upload--picture-card background-1 elevation-3" :class="field ? 'ml-0' : ''" v-show="canAdd">
						<v-icon>add</v-icon>
					</div>
					<div :id="'previews-' + id" style="display: contents;"></div>
				</div>
			</vue-dropzone>
		</v-expand-transition>

        <confirm-dialog
            :confirmModel="confirmDelete"
            mainTitle="Vuoi eliminare tutti i documenti?"
            secondTitle="Tutti i file associati a questa entità verranno eliminati in modo irreversibile."
            @update:confirmModel="confirmDelete = false"
            :atConfirm="deleteAll"
            :confirm="{label:'Procedi', color:'info'}"
        ></confirm-dialog>

		<v-dialog
			v-model="previewDialog"
			fullscreen
			ref="pdfPreview"
			hide-overlay
			eager>
			<v-card tile>
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3">Anteprima File</p>
					<v-spacer></v-spacer>
					<v-btn icon @click.native.stop="previewDialog = !previewDialog"><v-icon>close</v-icon></v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<object style="width:100%; height: 88vh;" v-if="previewFile" :data="previewFile" type="application/pdf"></object>

				<v-divider></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="closePreviewDialog()" color="red" text>Chiudi</v-btn>
					<v-btn @click="downloadPdf()" color="primary" text>Scarica</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</v-card>
</template>

<script>


export default {
	name: 'file-uploader',
	props: {
		id: {
			type: Number,
			default: null
		},
		startEmpty: {
			type: Boolean,
			default: false
		},
		attachableType: String,
		field: Object,
		options: {
			type: Object,
			default: () => {return new Object()}
		},
		elevation: {
			type: Number,
			default: 2
		}
	},

	data() {
		return {
			internalId: this.id,
			defaultOptions: {
				url: this.$store.getters.baseUrl + '/api/attachments/',
				timeout: 0,
				thumbnailWidth: 150,
				previewTemplate: this.template(),
				autoProcessQueue: this.id !== null && (this.id === 0 || this.id >= 1) ? true : false,
				maxFilesize: 50,
				maxThumbnailFilesize: 50,
				maxFiles: 100,
				headers: {'Authorization': 'Bearer ' + this.$store.getters.token},
				uploadMultiple: false,
				clickable: '.fileinput-button',
				previewsContainer: '#previews-' + this.id,
				ignoreHiddenFiles: true,
				addRemoveLinks: false,
				dictRemoveFile: 'Rimuovi',
				dictCancelUpload: 'Annulla Upload',
				dictDefaultMessage: '<div class="margin-auto "><span class="margin-auto inline-flex">Trascina qui <i class="material-icons fs18i pl5">cloud_upload</i></span></div>',
				dictMaxFilesExceeded: 'Hai raggiunto il limite di file',
				dictRemoveFileConfirmation:  "Sei sicuro di voler eliminare questo file?",
				dictFileTooBig: 'La dimensione del file è troppo grande'
			},
			mimeTypes: ['3ds', 'aac', 'ai', 'avi', 'bmp', 'cad', 'cdr', 'css', 'dat', 'dll', 'dmg', 'doc', 'eps', 'fla', 'flv', 'gif', 'html', 'indd', 'iso', 'jpeg', 'jpg', 'js', 'midi', 'mov', 'mp3', 'mpg', 'ovpn', 'pdf', 'pfx', 'php', 'png', 'ppt', 'psd', 'ps', 'raw', 'sql', 'svg', 'tif', 'txt', 'wmv', 'xls', 'xlsx', 'xml', 'zip'],
			confirmDelete: false,
			showFile: true,
			paths: [],
			progressIndeterminate: false,
			progressActive: false,
			isDestroy: false,
			showSkeleton :true,
			expand: true,
			loaded: false,
			previewDialog: false,
			previewFile: null,
			previewFileName: null
		}
	},

	watch: {
		paths() {
 			this.$eventBusUtility.$emit('paths', this.paths.map(file => file.id))
		}
	},

	computed: {

		uploadImmediately() {
			return this.id !== null && (this.id === 0 || this.id >= 1)
		},

		getFiles(){
			return this.$refs.myVueDropzone.getAcceptedFiles()
		},

		mergedOptions(){
			return {
				...this.defaultOptions,
				...this.options
			}
		},

		canAdd() {
			if(this.options.maxFiles) {
				if(this.paths.length < this.options.maxFiles) {
					return true
				} else {
					return false
				}
			}
			return true
		}

	},

	methods: {
		
		initDropzone() {

			if(this.uploadImmediately) {
				this.toggleProgress(true)
				let data = {
					id: this.internalId,
					attachable_type: this.attachableType
				}
	
				if(!this.startEmpty) {
					this.axios.post('attachmentslists/', data).then(response => {
						// get body data
						if (!this.$refs.myVueDropzone) return

						_.forEach(response.data.attachments, (attachment) => {
							this.paths.push(attachment)
		
							var displayName = attachment.ext && !attachment.name.endsWith('.' + attachment.ext)
								? attachment.name + '.' + attachment.ext
								: attachment.name
							this.$refs.myVueDropzone.manuallyAddFile({
								size: attachment.size,
								name: displayName,
								id: attachment.id,
								type: 'image/png',
								path: response.data.baseurl + attachment.path,
								thumbnail: attachment.thumbnail
							}, response.data.baseurl + attachment.path)
	
						})
	
						this.addPreviewButton()
						this.toggleProgress(false)
				
					}, response => {
						// error callback
					})
				} else {
					this.toggleProgress(false)
				}
			}
		},

		sendingEvent(file, xhr, formData) {
			formData.append('attachable_type', this.attachableType)
			formData.append('attachable_id', this.internalId)
		},

		deleteFile(file, error, xhr) {
			if(file.id) {
				if(!this.isDestroy) {
					let data = {
						ids: [file.id]
					}
					this.axios.post('attachments/delete', data).then(response => {
						let fileRemovedIndex =_.findIndex(this.paths, (p) => { return p.id == file.id})
						this.paths.splice(fileRemovedIndex, 1)

					}, () => {
						// Re-add the file to dropzone on error
						if (!this.$refs.myVueDropzone) return

						this.$refs.myVueDropzone.manuallyAddFile({
							size: file.size,
							name: file.name,
							id: file.id,
							type: file.type,
							path: file.path,
							thumbnail: file.thumbnail
						}, file.path)

						this.addPreviewButton()
						this.toggleProgress(false)

						this.$store.commit('setSnackbar', {
							timeout: 6000,
							text: 'Errore durante l\'eliminazione del file',
							value: true,
							color: 'error'
						})
					})
				}
			}
		},

		successUpload(file, response) {
			file['id'] = response.data.id
			file['path'] = response.data.baseurl + response.data.path
			file['thumbnail'] = response.data.thumbnail
			this.paths.push(response.data)
			this.thumbnail(file)
			this.toggleProgress(false)
			this.addPreviewButton()
		},

		template() {
			return `<div id="dz-prev-${this.id}" class="dz-prev dz-preview dz-file-preview elevation-3" style="margin:15px; border-radius: 6px;">

						<div style="display: flex; border-bottom: #ececec 1px solid; padding: 2px;">
							<button type="button" data-dz-remove="" class="dz-remove ma-0 v-btn v-btn--icon v-btn--round theme--light v-size--default" data-ripple="true">
								<span class="v-btn__content">
									<i aria-hidden="true" class="v-icon notranslate material-icons theme--light">close</i>						
								</span>
							</button>` +
							(this.id !== null && (this.id === 0 || this.id >= 1) ?
							`<button type="button" class="dz-button-prev ma-0  v-btn v-btn--icon v-btn--round theme--light v-size--default" data-ripple="true" style="margin: auto !important; margin-right: 4px !important">
								<span class="v-btn__content">
									<i aria-hidden="true" class="v-icon notranslate material-icons theme--light">search</i>						
								</span>
							</button>` : ``)
							+
						`</div>

						<div class="dz-image">
							<div data-dz-thumbnail-bg></div>
						</div>

						<div class="dz-details">
							<div class="dz-size"><span data-dz-size></span></div>
							<div class="dz-filename"><span data-dz-name></span></div>
						</div>

						<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
						<div class="dz-error-message"><span data-dz-errormessage></span></div>
						<div class="dz-success-mark"><i class="fa fa-check"></i></div>

						<div class="dz-error-mark"><i class="fa fa-close"></i></div>
							
					</div>`
		},

		thumbnail(file) {
			let ext = file.name.split('.').pop().toLowerCase()
			let j, len, ref, thumbnailElement
			if (file.previewElement) {
				if(this.id >= 0) {
					file.previewElement.onclick = () => {
						this.$eventBusUtility.getFile(this.$store, file.path, file.name)
					}
					file.previewElement.classList.remove('dz-file-preview')
				}
				ref = file.previewElement.querySelectorAll('[data-dz-thumbnail-bg]')
				for (j = 0, len = ref.length; j < len; j++) {
					thumbnailElement = ref[j]
					thumbnailElement.alt = file.name
					let filename = ext
					if(this.mimeTypes.indexOf(ext) == -1){
						filename = 'default'
					}
					if(file.thumbnail == null) {
						thumbnailElement.style.backgroundImage = 'url("/img/mime/' + filename + '.svg")'
					} else {
						thumbnailElement.style.backgroundImage = 'url(data:image/jpeg;base64,'+ file.thumbnail + ')'
					}
					
				}
			}
		},

		deleteAll() {
			this.$refs.myVueDropzone.removeAllFiles()
			this.paths = []
			this.confirmDelete = false

		},

		toggleProgress(condition) {
			if(this.id) {
				this.progressIndeterminate = condition
				this.progressActive = condition
			}
		},

		maxSizeExceded(file, error) {
			if(error != 'Upload canceled.') {
				this.$store.commit('setSnackbar', {timeout: 6000, text: 'Errore: ' + error, value: true, color: 'error'})
				this.$refs.myVueDropzone.removeFile(file)
				this.toggleProgress(false)
			}
		},

		maxFilesReached() {
			this.showSkeleton = true
		},

		downloadPdf() {
			var link = document.createElement('a')
          	link.href = this.previewFile
          	link.setAttribute("target", "_blank")
          	link.download = this.previewFileName
          	link.click()
		},

		closePreviewDialog() {
			this.previewDialog = !this.previewDialog
			this.previewFile = null
			this.previewFileName = null
		},

		openPreviewDialog(attachment) {
			this.previewDialog = true
			this.previewFileName = attachment.name

			this.$eventBusUtility.getFile(this.$store, '/files/' + attachment.path, attachment.name, true).then(data => {
				this.previewFile = data
			})
		},

		addPreviewButton() {
			let els = document.querySelectorAll('#dz-prev-' + this.id)
			for (let j = 0; j < els.length; j++) {
				let attachment = this.paths[j]
				if(attachment) {
					let buttonPreview = els[j].querySelector('.dz-button-prev')
					if(buttonPreview) {
						if(['pdf', 'jpg', 'jpeg', 'png', 'txt', 'svg'].includes(attachment.ext)) {
							buttonPreview.addEventListener("click", (e) => {
								e.cancelBubble = true
								e.stopPropagation()
								this.openPreviewDialog(attachment)
							})						
						} else {
							buttonPreview.remove()
						}
					}
				}
			}			
		}


	},

	mounted() {

		if (!this.field && this.attachableType && this.$store.getters.checkSettings('compact_' + this.attachableType + '_view')) {
			this.expand = false
		} else {
			this.expand = this.field || !this.$store.getters.checkSettings('compact_viewing')
		}

		this.$eventBusUtility.$on('refreshFileUploader', () => {
			_.forEach(this.paths, (path, key) => {
				this.paths.splice(key, 1)
			})
			document.querySelectorAll('#dz-prev-' + this.id).forEach(element => {
				element.remove()
			})
			this.initDropzone()
        })

		this.$eventBusUtility.$on('modelCreated', (id) => {
			this.internalId = id
			if (this.$refs.myVueDropzone) {
				this.$refs.myVueDropzone.processQueue()
			}
        })

	},

	beforeDestroy () {
		this.isDestroy = true
		this.$eventBusUtility.$off('refreshFileUploader')
		this.$eventBusUtility.$off('modelCreated')
	}
}
</script>

<style>
    #dropzone {
        height: 300px;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
    }

    #dropzone .dz-preview {
        width: 175px;
        min-width: 160px;
        display: inline-block;
        cursor: pointer;
        background: white;
        padding: 0px;

    }

    #dropzone .dz-preview .dz-image {
		width: 140px;
		height: 180px;
		margin: auto;
    }

    #dropzone .dz-preview .dz-image > div {
        width: inherit;
        height: inherit;
        background-size: contain;
		background-position: center;
    }

    #dropzone .dz-preview .dz-image > img {
        width: 100%;
    }

    #dropzone .dz-preview .dz-details {
        color: black;
        transition: opacity .2s linear;
        text-align: center;
		border-top: #ececec 1px solid;
    	padding: 4px;
    }

    #dropzone .dz-success-mark, .dz-error-mark {
        display: none;
    }

    .dz-filename {
        font-size: 12px;
    }

    .dz-size {
        font-size: 12px;
    }

    .dz-remove {
        margin: auto !important;
        display: flex;
        margin-right: 0px !important;
    }

    .el-upload {
        display: inline-block;
        text-align: center;
        cursor: pointer;
        outline: none;
    }

    .dz-message {
        display: inline;
    }

    .el-upload--picture-card {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 8px;
        box-sizing: border-box;
        width: 175px;
        height: 285px;
        cursor: pointer;
        line-height: 270px;
        vertical-align: top;
        margin: 15px;
    }

    .el-upload--picture-card:hover, .el-upload:focus {
        border-color: #409eff;
        color: #409eff;
    }

</style>